import { footerContactNewsletterInvalidError } from '@/domains/retention/Footer/translations';

export const getErrorMessage = (error: string | null) => {
  switch (error) {
    case 'invalid email':
      return footerContactNewsletterInvalidError;
    default:
      return undefined;
  }
};

export const getError = (error: string | null) => ({
  messageType: error ? ('danger' as const) : undefined,
  message: getErrorMessage(error),
});
